import React from "react";
import Styles from "./HallsItem.module.scss"
import {IHalls} from "./types";
import profileHallIcon from "../../../../assets/icons/hallType.svg";
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

const HallsItem: React.FC<IHalls> = (props) => {
    const date = new Date(props.data.date);
    const isValidDate = !isNaN(date.getTime());
    
    const formatDate = (dateObj: Date): string => {
        return format(dateObj, 'EEE, d MMMM yyyy', { locale: ru });
    };
    
    const formattedRentDate = isValidDate ? formatDate(date) : '';
    
    const purchaseDate = props.data.created_at ? new Date(props.data.created_at) : null;
    const isValidPurchaseDate = purchaseDate && !isNaN(purchaseDate.getTime());
    const formattedPurchaseDate = isValidPurchaseDate ? formatDate(purchaseDate) : '';
    
    const formattedPrice = props.data.price ? `${props.data.price} Р` : '';

    return(
        <div className={Styles.wrapper}>
            <div className={Styles.header}>
                <div className={Styles.header_left}>
                    <div className={Styles.icon}>
                        <img src={profileHallIcon} alt="Зал" />
                    </div>
                    <div className={Styles.title}>{props.data.hall?.title || 'Зал'}</div>
                </div>
                {formattedPrice && (
                    <div className={Styles.price}>{formattedPrice}</div>
                )}
            </div>
            <div className={Styles.content}>
                <div className={Styles.row}>
                    <span className={Styles.label}>Дата</span>
                    <span className={Styles.value}>{formattedRentDate}</span>
                </div>
                <div className={Styles.row}>
                    <span className={Styles.label}>Время</span>
                    <span className={Styles.value}>{props.data.time} - {props.data.time_to}</span>
                </div>
            </div>
        </div>
    )
}


export default HallsItem;
